import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { Icon, Heading, HeadingTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const HelpListItem = ({ title, onPress, isLast }) => (
  <TouchableOpacity
    onPress={onPress}
    style={styles.formHeader}>
    <Heading
      title={title}
      style={styles.formTitle}
      headingType={HeadingTypes.HEADING_TWO}
    />
    <Icon
      size={defaultScale(25)}
      color={Theme.GREY_DARK_MEDIUM}
      name={'ios-arrow-forward'}
    />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  formHeader: {
    paddingVertical: defaultScale(5),
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-between',
    borderBottomColor: Theme.GREY_LIGHT,
    borderBottomWidth: 0.5,
  },
  formTitle: {
    ...Theme.textStyle.bodyCopyMed,
    paddingVertical: defaultScale(15),
    color: Theme.GREY_DARK,
  },
});

export default HelpListItem;
